// export const GET_FINANCIAL_STATUSES_SUCCESS = 'GET_FINANCIAL_STATUSES_SUCCESS'; // useless now
export const GET_CLIENT_FILTERS_DATA_SUCCESS = 'GET_CLIENT_FILTERS_DATA_SUCCESS';
export const GET_CLIENT_FILTERS_DATA_FAILED = 'GET_CLIENT_FILTERS_DATA_FAILED';

export const GET_CLIENT_FINANCIALS_TOTALS_SUCCESS = 'GET_CLIENT_FINANCIALS_TOTALS_SUCCESS';
export const GET_CLIENT_FINANCIALS_LIST_SUCCESS = 'GET_CLIENT_FINANCIALS_LIST_SUCCESS';
export const GET_CLIENT_FINANCIALS_ALL_LIST_SUCCESS = 'GET_CLIENT_FINANCIALS_ALL_LIST_SUCCESS';
